export default __webpack_public_path__ + "static/media/icone-check.901f9863.svg";